import { render, staticRenderFns } from "./NoveltySectionComponent.vue?vue&type=template&id=421fd2fc"
import script from "./NoveltySectionComponent.vue?vue&type=script&lang=js"
export * from "./NoveltySectionComponent.vue?vue&type=script&lang=js"
import style0 from "./NoveltySectionComponent.vue?vue&type=style&index=0&id=421fd2fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports